import React from "react";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { easing } from "../../../lib/animations";
import { BlinkingDot } from "./BlinkingDot";
import { MonoLabel } from "./MonoLabel";

/**
 * Sticky-style section label used at the top of every subpage:
 * `· Section [xx]` on the left, breadcrumb `Proof / Current` on the right.
 */
export const SectionLabel = ({
    sectionNumber,
    crumb,
    homeHref = "/",
    rootLabel = "Proof",
    "data-testid": testId = "section-label",
}) => (
    <motion.div
        initial={{ opacity: 0, y: -10 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.7, ease: easing.primary }}
        data-testid={testId}
        style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            gap: 18,
            marginBottom: "clamp(36px, 5vw, 72px)",
            color: "var(--on-ink-soft)",
        }}
    >
        <MonoLabel
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 12,
                whiteSpace: "nowrap",
            }}
        >
            <BlinkingDot />
            Section [{sectionNumber}]
        </MonoLabel>
        <MonoLabel
            tone="mute"
            style={{
                display: "inline-flex",
                alignItems: "center",
                gap: 12,
            }}
        >
            <Link
                to={homeHref}
                style={{ color: "inherit", textDecoration: "none" }}
                data-testid="crumb-home"
            >
                {rootLabel}
            </Link>
            <span aria-hidden="true">/</span>
            <span style={{ color: "var(--on-ink-soft)" }}>{crumb}</span>
        </MonoLabel>
    </motion.div>
);

export default SectionLabel;
